import { gql } from '@apollo/client';

//returns a historicalPhone
export const PERSON_PHONE_HISTORY = gql`
  query personPhoneHistory($personId: ID!, $originatorId: ID!){
    personPhoneHistory(personId: $personId, originatorId: $originatorId) {
      id
      createdAt
      lastUpdated
      updatedAt
      value
      personalAttribute {
        id
        firstName
        middleName
        lastName
      }
    }
  }
`;